import { default as WJElement } from '../wje-element/element.js';
import Checkbox from './checkbox.element.js';

// export * from "./checkbox.element.js";
export default Checkbox;

WJElement.define('wje-checkbox', Checkbox);
